import React from 'react';

import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';

import {getParam} from '../utils/utils';
import { isNull, isEqual, isArray } from "lodash";



import * as d3Graphviz from 'd3-graphviz';

class D3Graphviz extends React.Component {

    constructor(props) {
        super(props);

        this.state = {};

        this.divViz = React.createRef();

        this.setImages = this.setImages.bind(this);

    }

    componentDidMount(){
        this.setup(); 
     }

     componentDidUpdate(prevProps, prevState){

        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

        if (!isEqual(this.state, prevState)){
            if (this.divViz.current){
                this.createVizSvg();
            }
        }


     }
 

    setup(){

        let StateChange = {
            dot: null,
            options: {
                engine:"dot",
                fit:false,
                width:null,
                height:null,
                zoom:false,
                scale:1
            },
            images: [],
            FullSize : true
        }

        StateChange.dot = getParam('dot', this.props);
        if (getParam('options', this.props)){
            StateChange.options = getParam('options', this.props);
        }
        StateChange.images = getParam('images', this.props);

        this.setState(StateChange);
    }


    xcreateVizSvg(){

/*
        d3Graphviz.graphviz(`#${this.divViz.current.id}`)
            .options(this.state.options)
            .addImage("images/stick.png", "50px", "50px")
            .renderDot(this.state.dot);
*/

        d3Graphviz.graphviz(`#${this.divViz.current.id}`).options(this.state.options)
        if (this.state.images){
            if (this.state.images.length){
                this.state.images.forEach((item) => (d3Graphviz.graphviz(`#${this.divViz.current.id}`).addImage(item.filename, item.height, item.width)))
            }
        }
        d3Graphviz.graphviz(`#${this.divViz.current.id}`).renderDot(this.state.dot,this.setImages);



        return;

    }

    createVizSvg() {
        const el = this.divViz.current;
        if (!el || !this.state.dot) return;

        const gv = d3Graphviz.graphviz(el).options(this.state.options);

        if (Array.isArray(this.state.images) && this.state.images.length) {
            this.state.images.forEach(img => {
            gv.addImage(img.filename, img.height, img.width);
            });
        }

        gv.renderDot(this.state.dot, this.setImages);

}



    setImages(){

        if (this.divViz.current){
            if (this.divViz.current.childNodes[0]){
                if (this.divViz.current.childNodes[0].tagName == 'svg'){
                    let svg = this.divViz.current.childNodes[0];
                    this.findSvgImage(svg);
                }   
            }

        }
        return;
    }

    findSvgImage(Document){
        if ('tagName' in Document){
            if (Document.tagName == 'image'){
                this.setSvgImage(Document);
            }
        }
        if ('children' in (Document)){
            for (let pos=0; pos<Document.children.length; pos++){
                let Child = Document.children[pos];
                this.findSvgImage(Child);
            }
        }

        return;

    }

    setSvgImage(Document){

        if (Document.attributes){
            if ('href' in Document.attributes){
                let ImageName = Document.attributes.href.nodeValue;
                for (let pos=0; pos<this.state.images.length;pos++){
                    let Image = this.state.images[pos];
                    if (Image.filename == ImageName){
                        Document.attributes.href.nodeValue = Image.object;
// this copes with being deployed at a web site domain
                        if (Image.object.startsWith("./")){
                            Document.attributes.href.nodeValue = `${window.location.origin}/${Image.object}`;
                        }
                    }
                }
            }
        }

        return;
    }


    render() {
        return (
            <div 
                className="viz-scroll"
                {...(this.props.onClick
                    ? { onClick: this.props.onClick }
                    : {})}
            >
                <div ref={this.divViz} id="graph" />
            </div>
        );
    }
}



export default function D3Graphviz_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <D3Graphviz {...props} navigation={navigation} location={location} params={params} />;
  }
